var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('setting-layout',{attrs:{"title":"Verify Account by Yoti"}},[_c('v-container',{staticClass:"mb-1"},[_c('v-flex',{class:{
            'error--text': _vm.error,
            'green--text': _vm.success,
        },attrs:{"text-center":""}},[(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.success)?_c('p',[_vm._v(_vm._s(_vm.success))]):_vm._e(),(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.error))]):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }